var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#0A1E60","fillRule":"evenodd","d":"M32.489 8.678c0 9.562-7.393 20.589-20.918 20.589A20.999 20.999 0 0 1 .3 26.014c.578.068 1.161.104 1.753.104 3.448 0 6.615-1.155 9.133-3.098-3.216-.062-5.93-2.152-6.865-5.029.446.087.904.13 1.381.13.666 0 1.32-.085 1.935-.253-3.361-.662-5.899-3.586-5.899-7.093 0-.032 0-.062.007-.094a7.34 7.34 0 0 0 3.33.903C3.102 10.292 1.8 8.072 1.8 5.56c0-1.324.365-2.567.993-3.637a20.983 20.983 0 0 0 15.152 7.563 7.151 7.151 0 0 1-.188-1.651C17.758 3.84 21.05.6 25.109.6c2.116 0 4.026.879 5.364 2.281a14.678 14.678 0 0 0 4.675-1.755 7.293 7.293 0 0 1-3.236 4.007 14.75 14.75 0 0 0 4.221-1.137 14.84 14.84 0 0 1-3.661 3.742c.01.308.017.624.017.94Z"}));
}

Twitter.defaultProps = {"viewBox":"0 0 37 30"};

module.exports = Twitter;

Twitter.default = Twitter;
